import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconSave = deprecatedComponent({
    displayName: 'IconSave',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            d: "M3 3.9C3 3.40294 3.40294 3 3.9 3H17.062C17.2808 3 17.492 3.07967 17.6563 3.22411L20.6943 5.89526C20.8886 6.06613 21 6.31238 21 6.57115V20.1C21 20.5971 20.5971 21 20.1 21H3.9C3.40294 21 3 20.5971 3 20.1V3.9Z",
            fill: "none"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M7.78509 3V7.41653H16.2116V3M20.6943 5.89526L17.6563 3.22411C17.492 3.07967 17.2808 3 17.062 3H3.9C3.40294 3 3 3.40294 3 3.9V20.1C3 20.5971 3.40294 21 3.9 21H20.1C20.5971 21 21 20.5971 21 20.1V6.57115C21 6.31238 20.8886 6.06613 20.6943 5.89526Z",
            stroke: "black",
            strokeWidth: 1.5,
            strokeLinejoin: "round"
        }), /*#__PURE__*/ React.createElement("circle", {
            cx: 12.0056,
            cy: 13.5419,
            r: 2.75751,
            fill: "none",
            stroke: "black",
            strokeWidth: 1.5
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconSave };
